module.exports = __webpack_public_path__ + "img/client-nile-vocational-academy.fe142034.jpeg";